export default __webpack_public_path__ + "static/media/phone_motorola-motoe-black-portrait.4207912f.png";